import { useLayoutEffect } from 'react';
const OVERFLOW_HIDDEN = 'hidden';
const OVERFLOW_AUTO = 'auto';
/**
 * Hook to hide global scroll (for body) with rendering of some components
 */
export function useLockBodyScroll() {
    useLayoutEffect(() => {
        // Prevent scrolling on mount
        setTimeout(() => {
            document.body.style.overflow = OVERFLOW_HIDDEN;
        }, 0);
        // Re-enable scrolling when component unmounts
        return () => {
            document.body.style.overflow = OVERFLOW_AUTO;
        };
    }, []); // Empty array ensures effect is only run on mount and unmount
}
